module.exports = Object.freeze({
    SITE_URL: "https://www.njg.com.hk/",
    NJG: "njg.com.hk",
    API_URL: "https://njg.com.hk/"
});



// WEBPACK FOOTER //
// ./src/config_prod.js